export default "__VITE_ASSET__Mq6Vx5ry__"